import { ExternalType } from "./type.js";
import { postTakeApartOrderData } from "./kujiale/getCreateOrderFileTask.js";
import { externalFactory } from "./externalFactory.js";
import { createOrderFileV2 } from "./caxa/directive/createOrderFileV2.js";
import { getSimpleOrderTaskInfo } from "./kujiale/getSimpleOrderTaskInfo.js";
const externalCreateOrderFileV2 = externalFactory(async (params) => {
  const { type, taskId } = params;
  switch (type) {
    case ExternalType.caxa:
      return await createOrderFileV2(params.arg, params.sequenceId, params.socketNext);
    case ExternalType.kujiale:
      await postTakeApartOrderData({
        takeApartOrderList: params.arg,
        softwareType: "kujiale"
      });
      return await getSimpleOrderTaskInfo({
        id: taskId || ""
      });
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
});
export { externalCreateOrderFileV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalCreateOrderFileV2.js